import React from 'react';
import styled from 'styled-components';
import { Button } from '@figure/frontlib-gui';
import { useRedirect, useSiteMaintenanceDownTime } from 'shared/hooks';
import { PageHeader } from 'shared/components/Typography';
import TimeoutImage from 'shared/assets/images/timeout.svg';

const ImageWrapper = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  margin-top: 1.6rem;
`;

export const SiteMaintenanceDownTimePage = () => {
  const { message, shouldShowDashboardLink } = useSiteMaintenanceDownTime();
  const { redirectToDashboard } = useRedirect();

  return (
    <>
      <PageHeader>{message}</PageHeader>

      <ImageWrapper>
        <img src={TimeoutImage} alt="site maintenance" />
      </ImageWrapper>

      {shouldShowDashboardLink && (
        <Button primary large center onClick={redirectToDashboard}>
          Go to dashboard
        </Button>
      )}
    </>
  );
};
